module.exports = __webpack_public_path__ + "img/icon-black-invoice.35212757.png";